import boilerBusdCakeLpFarmingPool from "../abis/production/boilerBusd/pools/boilerBusd";
import boilerSaunaCakeLpFarmingPool from "../abis/production/boilerSauna/pools/boilerSauna";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "BOILER/BUSD",
    temperature: 65,
    type: "busd",
    contractAddress: "0x69dDcA5e59d35eb6FDd7Db7De291ADfe99797D3f",
    minApr: 159,
    abi: boilerBusdCakeLpFarmingPool.abi,
    url: `${host}/0x69dDcA5e59d35eb6FDd7Db7De291ADfe99797D3f`,
    swapUrl: `${swapHost}/0xfD1dD9F98F5f5625ce243B1E817cbFa0594AbAeA/0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56`,
    pairUrl: `${pairHost}/0xA7a27776f3008D2A6A580e26a1744DB900e74580`,
  },
  {
    title: "BOILER/SAUNA",
    temperature: 65,
    type: "sauna",
    contractAddress: "0x6902Fe89481846e7FA015C512f296F8ef529562f",
    minApr: 159,
    abi: boilerSaunaCakeLpFarmingPool.abi,
    url: `${host}/0x6902Fe89481846e7FA015C512f296F8ef529562f`,
    swapUrl: `${swapHost}/0xfD1dD9F98F5f5625ce243B1E817cbFa0594AbAeA/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0xf9Faf193E50AC5B216f2A939CD3Acb5Bef2b7903`,
  },
];
